import BaseWrapper from "../../components/BaseWrapper/BaseWrapper"
import Content from "./Content"

const SingleCustomer = () => <BaseWrapper content={<Content/>} />

export default SingleCustomer